import script from "./photoGalleryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./photoGalleryComponent.vue?vue&type=script&setup=true&lang=js"

import "./photoGalleryComponent.vue?vue&type=style&index=0&id=6d7785cc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7785cc"]])

export default __exports__